<template>
  <TextField
      :value="value"
      :name="name"
      :max="8"
      :required="required"
      :rules="rules"
      noCounter
      @input="onInput"
  />
</template>

<script>
import TextField from "@/components/atoms/TextField";
import ComponentMixin from "@/components/ComponentMixin";
export default {
  mixins: [ComponentMixin],
  type: "molecule",
  name: "PostalCodeField",
  components: {TextField},
  props: {
    value: {
      type: String | null,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    rules () {
      return [
        value => {
          if (value) {
            const result = value.match(/^\d{3}-?\d{4}$/g)
            if (!result) {
              return this.error("invalidFormat");
            }
          }
          return true;
        }
      ]
    },
  },
  methods: {
    onInput (value) {
      if (value && value.match(/^\d{7}$/)) {
        value = `${value.substr(0, 3)}-${value.substr(3, 4)}`;
      }
      this.$emit("input", value);
    }
  }
}
</script>

<style scoped>

</style>
